import styled from 'styled-components';

export const Container = styled.div`
  .btn-clean-search,
  .btn-clean-search:hover {
    background: ${(props) => props.theme.$white};
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 0 0.2rem 0.2rem 0;
    border-left-width: 0;
  }
`;
